import ReportTablePage from './ReportTablePage'

export default ReportTablePage



// WEBPACK FOOTER //
// ./src/pages/ReportTablePage/index.js